var render = function render(){var _vm=this,_c=_vm._self._c;return _c('star-rating',{attrs:{"increment":0.5,"max-rating":_vm.schema.maxRating,"star-size":40},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }